import React ,  { useState , useEffect } from 'react';
import './index.scss';
import Products from "../../components/templates/products/Products";
import CategoryService from "../../shared/services/CategoryService";
import EntityService from "../../shared/services/EntityService";
import PSLoading from "../../components/PSLoading";
import {Routes} from "../../../routes";
import { useHistory } from 'react-router-dom';

export default function ProductsPage() {

  const [showModalNewCategory, setShowModalNewCategory] = useState(false);
  const [listCategories, setListCategories] = useState([]);
  const [listProducts,setListProducts] = useState([]);
  const [newCategory, setNewCategory] = useState({description: '', favorite: false});
  const [loading, setLoading] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);
  const [currentIdCategory, setCurrentIdCategory] = useState(-1);
  const [loadingAction, setLoadingAction] = useState(-1);
  const history = useHistory();

  const createProduct= ( )=>{
    history.push(Routes.CMS_PRODUCT_ITEM);
  };

  const deleteProducts =  async (news) => {
    try{
      setLoadingAction(news.id);
      await EntityService.responseDeleteEntity(news.id);
      const filterProducts = listProducts.filter(item => item.id !== news.id)
      setListProducts([...filterProducts]);
      setLoadingAction(-1);
    }catch (error){
      setLoadingAction(-1);
    }
  };

  const loadProducts = async () => {
    try{
      setLoading(true);
      //products 2
      const response = await EntityService.responseGetEntity(2);
      setListProducts([...response.data]);
      setLoading(false);
    }catch (error){
      setLoading(false);
    }
  };

  const editProduct =  async (product, id) => {
    try{
      setLoadingAction(id);
      await EntityService.responseEditEntity(product, id);
      setLoadingAction(-1);
    }catch (error){
      setLoadingAction(-1);
    }
  };


  const changeCategoryProduct = async (value, news, index) => {
    const productEdit = {...news, idCategory : value };
    let formData = new FormData();
    formData.append('idEntity', news.idEntity);
    formData.append('idCategory', value);
    formData.append('title', news.title);
    formData.append('description', news.description);
    await editProduct(formData, news.id);

    listProducts[index] = productEdit;
    setListProducts([...listProducts]);
  };


  const onChangeCategory = (value, property) => {
    setNewCategory({...newCategory,[property]: value })
  };

  const saveCategory =  async () => {
    try{
      if(newCategory && newCategory.description){
        setLoadingSave(true);
        await CategoryService.responseSaveCategory(newCategory);
        setLoadingSave(false);
        setShowModalNewCategory(false);
        setNewCategory(null);
        await loadCategory();
      }

    }catch (error){
      setLoadingSave(false);
    }
  };

  const editCategory =  async () => {
    try{
      if(newCategory.description){
        setLoadingSave(true);
        await CategoryService.responseUpdateCategory(currentIdCategory,
          {
            ...newCategory,
            idOrganization: 2,
          }
        );
        setLoadingSave(false);
        setShowModalNewCategory(false);
        setNewCategory(null);
        await loadCategory();
      }

    }catch (error){
      setLoadingSave(false);
    }
  };

  const loadCategory =  async () => {
    try{
      const response = await CategoryService.responseGetCategory();
      setLoading(false);
      setListCategories([...response.data]);
    }catch (error){
      setLoading(false);
    }
  };

  const deleteCategory =  async (id) => {
    try{
      await CategoryService.responseDeleteCategory(id);
      const filterCategories = listCategories.filter(item => item.id !== id)
      setListCategories([...filterCategories]);
    }catch (error){
    }
  };

  useEffect(()=>{
    loadProducts();
    loadCategory();
  },[]);

  return (
    <div className="container-products">
      {
        loading ?
          <div className="d-flex-center ">
            <PSLoading color='red'/>
          </div>:
          <Products
            listCategories={listCategories}
            onCreateNewCategory = {()=>setShowModalNewCategory(true)}
            showModalNewCategory = {showModalNewCategory}
            saveCategory ={saveCategory}
            editCategory ={editCategory}
            onChangeCategory ={onChangeCategory}
            setCategory = {(value)=>setNewCategory(value)}
            selectCurrentIdCategory = {(id)=>setCurrentIdCategory(id)}
            loadingSave={loadingSave}
            currentIdCategory={currentIdCategory}
            onCloseModal = {()=>setShowModalNewCategory(false)}
            listProducts={currentIdCategory ===-1 ? listProducts : listProducts.filter(item=> item.idCategory===currentIdCategory)}
            loadingAction={loadingAction}
            deleteProducts={deleteProducts}
            onCreateProduct={createProduct}
            deleteCategory={deleteCategory}
            newCategory={newCategory}
            onEditCategory = {editCategory}
            editProduct = {(product)=>history.push(`${Routes.CMS_PRODUCT_ITEM}/${product.id}`)}
            onEditProduct = {editProduct}
            onChangeCategoryProduct={changeCategoryProduct}

          />
      }
    </div>
    )
 ;
}
